import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const PaymentPlanHistoryStyleWrapper = ({
  isMobile,
  children,
}: {
  isMobile: boolean;
  children: React.ReactNode;
}) => {
  if (isMobile) {
    return (
      <div
        css={css`
          border: 1px solid ${theme.colors.neutral20};
          border-radius: ${theme.borderRadius.medium};
          padding: ${theme.spacing(0, 2)};
          margin-top: ${theme.spacing(4)};
        `}
      >
        {children}
      </div>
    );
  }
  return <>{children}</>;
};
